export const WORKER_ROLES = ['frame_worker', 'sewer', 'upholsterer'];
export const MANAGEMENT_ROLES = ['admin', 'manager'];

const CAPABILITIES = {
  viewDashboard: MANAGEMENT_ROLES,
  viewPlan: ['admin', 'manager', 'seller'],
  viewTasks: [...MANAGEMENT_ROLES, ...WORKER_ROLES],
  viewWorkers: MANAGEMENT_ROLES,
  viewInventory: MANAGEMENT_ROLES,
  viewDeliveries: [...MANAGEMENT_ROLES, 'driver'],
  viewCompanySalary: MANAGEMENT_ROLES,
  viewOwnSalary: WORKER_ROLES,
  viewForecast: MANAGEMENT_ROLES,
  viewSettings: ['admin'],
  createSofa: ['admin', 'seller'],
  editSofa: MANAGEMENT_ROLES,
  deleteSofa: ['admin'],
  reorderSofas: MANAGEMENT_ROLES,
  assignSofaWorkers: MANAGEMENT_ROLES,
  archiveSofa: MANAGEMENT_ROLES,
  manageModels: MANAGEMENT_ROLES,
  deleteModel: ['admin'],
  manageInventory: ['admin'],
  manageDeliveries: MANAGEMENT_ROLES,
  deleteDelivery: ['admin'],
  manageUsers: ['admin'],
};

export const can = (userOrRole, capability) => {
  const role = typeof userOrRole === 'string' ? userOrRole : userOrRole?.role;
  return Boolean(role && CAPABILITIES[capability]?.includes(role));
};

export const canViewSalary = (userOrRole) =>
  can(userOrRole, 'viewCompanySalary') || can(userOrRole, 'viewOwnSalary');

export const defaultPathForRole = (role) => {
  if (role === 'driver') return '/deliveries';
  if (WORKER_ROLES.includes(role)) return '/tasks';
  if (role === 'seller') return '/plan';
  return '/';
};
